import {
	ApprovalIcon,
	ConfigurationsSvg,
	DashboardSvg,
	EmailSvg,
	EmployeeSvg,
	PasswordSvg,
	PayrollSettings,
	PayrollSvg,
	ReportSvg,
	RoleSvg,
	TimeActivitiesSvg,
	UsersSvg,
	CoaIcon,
	LeaveRequestSvg,
} from 'utils/svgs';

export const FORMDATA = {
	loginFields: [
		{
			title: 'Email Address',
			id: 'email',
			type: 'text',
			name: 'email',
			svg: <EmailSvg />,
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your email address',
					validateTrigger: 'onChange',
				},
				{
					type: 'email',
					message: 'Please enter valid e-mail',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Password',
			id: 'password',
			type: 'password',
			name: 'password',
			svg: <PasswordSvg />,
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your password',
					validateTrigger: 'onChange',
				},
				// {
				// 	pattern:
				// 		/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!])(?!.*\s).{8,16}$/,
				// 	message:
				// 		'Password should have minimum 8 characters at least 1 uppercase, 1 lowercase, 1 number and 1 special character',
				// 	validateTrigger: 'onChange',
				// },
			],
		},
	],
	resetPassword: [
		{
			title: 'Full Name',
			id: 'fullName',
			type: 'text',
			name: 'fullName',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your full name',
					validateTrigger: 'onChange',
				},
				{
					max: 30,
					message: 'Full name length must be less than 30 characters',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'New Password',
			id: 'password',
			type: 'password',
			name: 'password',
			svg: <PasswordSvg />,
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your password',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Confirm Password',
			id: 'confirmPassword',
			type: 'password',
			name: 'confirmPassword',
			svg: <PasswordSvg />,
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your password again',
					validationTrigger: 'onChange',
				},
				({ getFieldValue }: any) => ({
					validator(_: any, value: any) {
						if (!value || getFieldValue('password') === value) {
							return Promise.resolve();
						}
						return Promise.reject(
							new Error('Passwords do not match')
						);
					},
					validateTrigger: 'onChange',
				}),
			],
		},
	],
	forgotPassword: [
		{
			title: 'Email Address',
			id: 'email',
			type: 'text',
			name: 'email',
			svg: <EmailSvg />,
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your email address',
					validateTrigger: 'onChange',
				},
				{
					type: 'email',
					message: 'Please enter valid e-mail',
					validateTrigger: 'onChange',
				},
			],
		},
	],
	settingsMenuItems: [
		{
			key: 'users',
			icon: <UsersSvg />,
			label: 'Users',
		},
		{
			key: 'roles',
			icon: <RoleSvg />,
			label: 'Roles',
		},
		{
			key: 'payroll-settings',
			icon: <PayrollSettings />,
			label: 'Payroll Settings',
		},
		{
			key: 'fnf-clearance',
			icon: <ApprovalIcon />,
			label: 'FnF Clearance',
		},
		{
			key: 'payroll-wizard',
			icon: <ConfigurationsSvg />,
			label: 'Configurations',
		},
		{
			key: 'approval',
			icon: <ConfigurationsSvg />,
			label: 'Approval',
		},
		{
			key: 'notification',
			icon: <ConfigurationsSvg />,
			label: 'Notification',
		},
		{
			key: 'coa',
			icon: <CoaIcon />,
			label: 'Chart of Accounts',
		},
	],
	configurationMenuItems: [
		{
			key: 'company',
			label: 'Company',
		},
		{
			key: 'branch-code',
			label: 'Branch code',
		},
		{
			key: 'category-code',
			label: 'Category code',
		},
		{
			key: 'department',
			label: 'Department ',
		},
		{
			key: 'cost-center',
			label: 'Cost Center ',
		},
		{
			key: 'shift',
			label: 'Shift',
		},
		{
			key: 'job-title',
			label: 'Job Title',
		},
		// {
		// 	key: 'earning',
		// 	label: 'Earning',
		// },
		// {
		// 	key: 'deduction',
		// 	label: 'Deduction',
		// },
		{
			key: 'leave-type',
			label: 'Leave Type',
		},
		{
			key: 'holidays',
			label: 'Holidays',
		},
	],
	PayrollSettingsMenuItems: [
		{
			key: 'company-setup',
			label: 'Company Setup',
		},
		{
			key: 'pay-period',
			label: 'Pay Period',
		},
		{
			key: 'pay-group',
			label: 'Pay Group',
		},
		{
			key: 'statutory-components',
			label: 'Statutory Components',
		},
		{
			key: 'earning-code',
			label: 'Earnings Code',
		},
		{
			key: 'deduction-code',
			label: 'Deduction Code',
		},
		{
			key: 'mid-month-pay',
			label: 'Mid-Month Pay',
		},
		{
			key: 'opening-balance',
			label: 'Opening Balance',
		},
		// {
		// 	key: 'payroll-history',
		// 	label: 'Payroll history',
		// },
	],
	ReportMenuItems: [
		{
			key: 'napsa',
			label: 'NAPSA',
		},
		{
			key: 'nhima',
			label: 'NHIMA',
		},
		{
			key: 'paye',
			label: 'PAYE',
		},
		{
			key: 'p-18',
			label: 'P-18',
		},
		{
			key: 'p-13',
			label: 'P-13',
		},
		{
			key: 'payroll-summary',
			label: 'Payroll Summary',
		},
		{
			key: 'payroll-summary-employee',
			label: 'Employee Summary ',
		},
		{
			key: 'attendance-report',
			label: 'Attendance',
		},
		{
			key: 'net-pay',
			label: 'Net Pay',
		},
		{
			key: 'earnings',
			label: 'Earnings',
		},
		{
			key: 'deductions',
			label: 'Deductions',
		},
		{
			key: 'journal-entry',
			label: 'Journal Entry',
		},
		{
			key: 'leave-encashment',
			label: 'Leave Encashment',
		},
		{
			key: 'gratuity',
			label: 'Gratuity',
		},
		{
			key: 'leave-type',
			label: 'Leave Type',
		},
		{
			key: 'loan-movement',
			label: 'Loan Movement',
		},
	],
	approvalMenuItems: [
		{
			key: 'employee',
			label: 'Employee',
		},
	],
	pageMenuItems: [
		{
			key: 'dashboard',
			label: 'Dashboard',
			icon: <DashboardSvg />,
		},
		{
			key: 'employees',
			label: 'Employees',
			icon: <EmployeeSvg />,
		},
		{
			key: 'time-off',
			label: 'Time Off',
			icon: <LeaveRequestSvg />,
		},
		{
			key: 'time-activities-main',
			label: 'Time Activities',
			icon: <TimeActivitiesSvg />,
			children: [
				{
					key: 'daily-attendance',
					label: 'Daily Attendance',
					icon: '',
				},
				{
					key: 'monthly-summary',
					label: 'Monthly Summary',
					icon: '',
				},
				{
					key: 'shifts',
					label: 'Time Shift',
					icon: '',
				},
				{
					key: 'time-sheets',
					label: 'Time Sheets',
					icon: '',
				},
				{
					key: 'time-off',
					label: 'Leave Request',
					icon: '',
				},
				{
					key: 'assign-supervisor',
					label: 'Assign Supervisor',
					icon: '',
				},
				{
					key: 'time-logs',
					label: 'Time Logs',
					icon: '',
				},
			],
		},
		{
			key: 'run-payroll-main',
			label: 'Payroll',
			icon: <PayrollSvg />,
			children: [
				{
					key: 'mid-month',
					label: 'Mid Month Pay',
					icon: '',
				},
				{
					key: 'loan-request',
					label: 'Loan Request',
					icon: '',
				},
				{
					key: 'calculate-statutory-components',
					label: 'Calculate Statutory Components',
					icon: '',
				},

				{
					key: 'run-payroll',
					label: 'Run Payroll',
					icon: '',
				},
				// {
				// 	key: 'payments',
				// 	label: 'Payments',
				// 	icon: '',
				// },
			],
		},
		{
			key: 'reports',
			label: 'Reports',
			icon: <ReportSvg />,
		},
	],
	addUserFields: [
		{
			title: 'Full Name',
			id: 'fullName',
			type: 'text',
			name: 'fullName',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter your full name',
					validateTrigger: 'onChange',
				},
				{
					max: 30,
					message: 'Full name length must be less than 30 characters',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Email Address',
			id: 'email',
			type: 'text',
			name: 'email',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please enter email address',
					validateTrigger: 'onChange',
				},
				{
					type: 'email',
					message: 'Please enter valid email address',
					validateTrigger: 'onChange',
				},
			],
		},
		{
			title: 'Select Role',
			id: 'roleName',
			type: 'text',
			name: 'roleName',
			defaultValue: '',
			placeholder: 'Enter role name',
			placeHolder: '',
			required: true,
			rules: [
				{
					required: true,
					message: 'Please select role',
					validateTrigger: 'onChange',
				},
			],
		},
	],
};

export const roleDataSource: any = [];
roleDataSource.push({
	name: `Admin`,
	description: `Description for role`,
	permissions: `Permission Details`,
	status: true,
	action: `some action`,
});

for (let index = 0; index < 15; index++) {
	roleDataSource.push({
		name: `Role ${index}`,
		description: `Description for role ${index}`,
		permissions: `Permission Details`,
		status: index % 2 === 0,
		action: `some action`,
	});
}

export const roleColumns = [
	{
		title: 'Role Name',
		dataIndex: 'name',
		key: 'name',
		sorter: (a: any, b: any) => {
			return a.name.length - b.name.length;
		},
		sortDirections: ['descend'],
	},
	{
		title: 'Description',
		dataIndex: 'description',
		key: 'description',
	},
	{
		title: 'Status',
		dataIndex: 'status',
		key: 'status',
	},
	{
		title: 'Permissions',
		dataIndex: 'permissions',
		key: 'permissions',
	},
	{
		title: 'Action',
		dataIndex: 'action',
		key: 'action',
	},
];

export const UserProfileData = [
	{
		title: 'First Name',
		id: 'firstName',
		type: 'text',
		name: 'firstName',
		defaultValue: '',
		disabled: false,
		errorMessage: 'Please enter your first name',
		required: true,
		rules: [
			{
				required: true,
				message: 'Please enter your first name',
				validateTrigger: 'onChange',
			},
			{
				min: 2,
				max: 40,
				message: 'First name must be between 2 and 40 characters',
				validateTrigger: 'onChange',
			},
		],
	},
	{
		title: 'Last Name',
		id: 'lastName',
		type: 'text',
		name: 'lastName',
		defaultValue: '',
		disabled: false,
		errorMessage: 'Please enter your last name',
		required: true,
		rules: [
			{
				required: true,
				message: 'Please enter your last name',
				validateTrigger: 'onChange',
			},
			{
				min: 2,
				max: 40,
				message: 'Last name must be between 2 and 40 characters',
				validateTrigger: 'onChange',
			},
		],
	},
	{
		title: 'Email Address',
		id: 'email',
		type: 'text',
		name: 'email',
		defaultValue: '',
		disabled: true,
		errorMessage: 'Please enter your email',
		required: false,
		rules: [],
	},
	{
		title: 'Role',
		id: 'role',
		type: 'text',
		name: 'role',
		defaultValue: '',
		disabled: true,
		errorMessage: 'Please enter your role',
		required: true,
		rules: [
			{
				required: true,
				message: 'Please enter your role',
				validateTrigger: 'onChange',
			},
			{
				min: 2,
				max: 40,
				message: 'Role must be between 2 and 40 characters',
				validateTrigger: 'onChange',
			},
		],
	},
	// {
	// 	title: 'Phone Number',
	// 	id: 'phone',
	// 	type: 'number',
	// 	name: 'phone',
	// 	required: false,
	// 	rules: [
	// 		{
	// 			validator: phoneNumberValidator,
	// 			message: 'Please enter valid phone number',
	// 			validateTrigger: 'onChange',
	// 		},
	// 	],
	// },
];

export const monthNames = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];

export const months = [
	{ value: 1, label: 'January' },
	{ value: 2, label: 'February' },
	{ value: 3, label: 'March' },
	{ value: 4, label: 'April' },
	{ value: 5, label: 'May' },
	{ value: 6, label: 'June' },
	{ value: 7, label: 'July' },
	{ value: 8, label: 'August' },
	{ value: 9, label: 'September' },
	{ value: 10, label: 'October' },
	{ value: 11, label: 'November' },
	{ value: 12, label: 'December' },
];

export const booleanOptions = [
	{
		label: 'Yes',
		value: 'true',
	},
	{
		label: 'No',
		value: 'false',
	},
];

export const configurationModules = [
	'Branch Code',
	'Departments',
	'Job Title',
	'Payment Type',
	'Payment Method',
	'Earning',
	'Deduction',
	'Cost Center',
	'Category',
	'Leave Type',
	'Holidays',
];

export const payrollModules = [
	'Company Setup',
	'Pay Period',
	'Statutory Components',
	'Pay Schedule',
	'Payroll History',
	'Mid-Month Pay Setup',
	'Earning Code',
	'Deduction Code',
];

export const deductionFormula = {
	D1: 'First K 4, 000.00 @ 0% - 0, Next K 800.00 @ 25% - 200.00, Next K 2, 100.00 @ 30% - 630.00, Balance K 8, 100.00 @ 37.5% - 3,037.50',
	D2: '10% of total earnings (5% employee share/5% employer share)',
	D3: '2% of Basic pay (1% employee share / 1% employer share)',
	D4: 'K 200 fix as of now',
	D5: 'deduct in March and June - 7.5K in both the months',
	D6: '0.5% of total Gross emoluments',
};

export const earningsFormulaMapping = {
	'SALARY RATE': 'SAL',
	'OT HOURS': 'OTH',
	'BASIC PAY': 'BSP',
	'LEAVE DAYS': 'LVD',
	'SHIFT DIFFERENCE HOURS': 'SDH',
	'NO. OF MONTHS WORKED': 'NMW',
	'NO. OF DAYS WORKED': 'NDW',
	'MID MONTH AMOUNT': 'MMA',
};

export const deductionFormulaOptions = [
	{
		value: 'D1',
		label: 'D1',
	},
	{
		value: 'D2',
		label: 'D2',
	},
	{
		value: 'D3',
		label: 'D3',
	},
	{
		value: 'D4',
		label: 'D4',
	},
	{
		value: 'D5',
		label: 'D5',
	},
	{
		value: 'D6',
		label: 'D6',
	},
];

export const displayFormatdropdownOptions = [
	{ label: '1,234,4567', value: 1 },
	{ label: '12,34,567', value: 2 },
];

export const currencyPositionDropdownOptions = [
	{ label: 'Before', value: 'BEFORE' },
	{ label: 'After', value: 'AFTER' },
];

export const decimalPlacesdropdownOptions = [
	{ label: '0', value: 0 },
	{ label: '1', value: 1 },
	{ label: '2', value: 2 },
	{ label: '3', value: 3 },
	{ label: '4', value: 4 },
];

export const thousandSeparatordropdownOptions = [
	{ label: '(.)Dot', value: 'DOT' },
	{ label: '(,)Coma', value: 'COMA' },
];

export const negativeNumberdropdownOptions = [
	{ label: 'with negative sign(eg: -123)', value: 'MINUS' },
	{ label: 'within parenthesis(eg: (123))', value: 'BRACKETS' },
];

export const dateFormats = [
	{ label: 'MM/DD/YYYY', value: 'MM/DD/YYYY' },
	{ label: 'DD/MM/YYYY', value: 'DD/MM/YYYY' },
	{ label: 'YYYY/MM/DD', value: 'YYYY/MM/DD' },
];

export const monthsForCompanySetup = [
	{ label: 'January', value: 1 },
	{ label: 'February', value: 2 },
	{ label: 'March', value: 3 },
	{ label: 'April', value: 4 },
	{ label: 'May', value: 5 },
	{ label: 'June', value: 6 },
	{ label: 'July', value: 7 },
	{ label: 'August', value: 8 },
	{ label: 'September', value: 9 },
	{ label: 'October', value: 10 },
	{ label: 'November', value: 11 },
	{ label: 'December', value: 12 },
];
